import { useState, useEffect } from "react";
import { List, ListItem, ListItemText, IconButton, CircularProgress, ListItemSecondaryAction, Snackbar, Alert, Button, Fab, Box } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import axios from "axios";
import CheckIcon from "@mui/icons-material/Check";
import ErrorIcon from "@mui/icons-material/Error";


export default function UsersReportList({ token, groupId }) {
  const [users, setUsers] = useState([]);
  const [reportingId, setReportingId] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });


  console.log('token', token)

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/groups/${groupId}?populate=*`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setUsers(res.data?.data?.attributes?.users || []);
      } catch (err) {
        console.error("Błąd pobierania użytkowników grupy", err);
      }
    };

    if (groupId) fetchUsers();
  }, [groupId, token]);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleGenerateReport = async (userId) => {
    console.log('userId', userId)
    setReportingId(userId);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/reports/student/${userId}`,
        {
          type: "training"
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSnackbar({
        open: true,
        message: `Raport dla użytkownika został wygenerowany.`,
        severity: "success",
      });
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Nie udało się wygenerować raportu.",
        severity: "error",
      });
    } finally {
      setReportingId(null);
    }
  };

  const handleGenerateReportForAll = async () => {
    if (!users.data || users.length === 0) return;

    setReportingId('all');

    const failedUsers = [];
    const promises = users?.data.map(async (user) => {
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/reports/student/${user.id}`,
          {
            type: "training"
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } catch (err) {
        console.error(`Błąd dla usera ${user.id}:`, err);
        failedUsers.push(user.attributes.username);
      }
    });

    try {
      await Promise.all(promises);

      if (failedUsers.length === 0) {
        setSnackbar({
          open: true,
          message: `Raporty dla wszystkich ${users?.data?.length} użytkowników zostały wygenerowane.`,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: `Raporty wygenerowane dla ${users?.data?.length - failedUsers.length}/${users?.data?.length} użytkowników. Błędy dla: ${failedUsers.join(', ')}`,
          severity: "warning",
        });
      }
    } catch (err) {
      console.error('Nieoczekiwany błąd:', err);
      setSnackbar({
        open: true,
        message: "Wystąpił nieoczekiwany błąd podczas generowania raportów.",
        severity: "error",
      });
    } finally {
      setReportingId(null);
    }
  };


  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Fab variant="extended" size="small" color="primary" aria-label="add" onClick={handleGenerateReportForAll}>
          <AssignmentIcon />
          Generuj wszystkim
        </Fab>
      </Box>
      <List>

        {users?.data?.map((user) => (
          <ListItem key={user.id} divider>
            <ListItemText
              primary={`${user.attributes.firstname} ${user.attributes.lastname}`}
              secondary={user.attributes.username}
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                color="primary"
                onClick={() => handleGenerateReport(user.id)}
                disabled={reportingId === user.id}
              >
                {reportingId === user.id ? <CircularProgress size={24} /> : <AssignmentIcon />}
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          icon={snackbar.severity === "success" ? <CheckIcon fontSize="inherit" /> : <ErrorIcon fontSize="inherit" />}
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}